import { Button, Col, Popconfirm, Row, Space, theme } from 'antd';
import { FC } from 'react';
import { BoxArrowUpRight, ExclamationCircle, Trash } from 'react-bootstrap-icons';

import { DescriptionBlock } from '../../../../../common/components';
import { CommonDrawerTitle } from '../../../../../common/layouts';
import { DomainRegistrar } from '../../../entities';

interface Props {
  domainRegistrar: DomainRegistrar;
  isDeleteDomainRegistrtarLoading: boolean;
  isDomainRegistrarAccountsListMutating: boolean;
  handleDeleteDomainRegistrtar: () => void;
}

export const DomainRegistrarsOverviewView: FC<Props> = ({
  domainRegistrar,
  isDeleteDomainRegistrtarLoading,
  isDomainRegistrarAccountsListMutating,
  handleDeleteDomainRegistrtar
}: Props) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Popconfirm
              disabled={ isDeleteDomainRegistrtarLoading || isDomainRegistrarAccountsListMutating }
              title="Видалити цей проксі-сервер?"
              onConfirm={ handleDeleteDomainRegistrtar }
              okType="danger"
              okText="Так"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              placement="bottomRight"
            >
              <Button
                loading={ isDeleteDomainRegistrtarLoading }
                disabled={ isDeleteDomainRegistrtarLoading || isDomainRegistrarAccountsListMutating }
                danger
                icon={ <Trash/> }
              >
                Видалити
              </Button>
            </Popconfirm>
          </Space>
        }
      />

      <Row gutter={ [16, 16] }>
        <Col span={ 24 }>
          <DescriptionBlock items={ [['Назва', domainRegistrar.name]] }/>
          <DescriptionBlock
            items={ [
              [
                'Посилання',
                <a key={ domainRegistrar.link } href={ domainRegistrar.link } target="_blank" rel="noreferrer">
                  { domainRegistrar.link }&nbsp;
                  <BoxArrowUpRight/>
                </a>
              ]
            ] }
          />
        </Col>
      </Row>
    </>
  );
};
